/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'VolChart': {
    width: 302,
    height: 49,
    viewBox: '0 0 302 49',
    data: '<defs><linearGradient x1="-34.449%" y1="62.968%" x2="166.089%" y2="62.968%" id="svgicon-VolChart-a"><stop stop-color="#FFF" stop-opacity=".761" offset="0%"/><stop stop-color="#FFF" offset="100%"/></linearGradient></defs><g _fill="none" fill-rule="evenodd"><path pid="0" _fill="#CADCFF" opacity=".3" d="M0 12.262h302v23.213H0z"/><path pid="1" _fill="url(#svgicon-VolChart-a)" d="M0 12.262h180v23.213H0z"/><path pid="2" d="M202.25 48.36V0" _stroke="#CADCFF" stroke-linecap="square" stroke-dasharray="3,3,3"/></g>'
  }
})
